import React from 'react'
import {Link} from "react-router-dom"
import {Container, Row, Col} from "react-bootstrap"

function PageNotFound() {
    return (
        

        <Container fluid className="text-center">
            {/* SEZIONE BANNER */}
        <Container fluid className="head-banner text-white text-center" id="banner_accesso">
            <Row>
                <Col>
                    <h1><strong>8-Bit Motors</strong></h1>
                </Col>
            </Row>
        </Container>

             <h1>Pagina non disponibile.</h1>
            <h3>Ritorna alla <Link to={"/"}>Home</Link></h3>
            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            
        </Container>
    )
}

export default PageNotFound;
